/**
 * Module 35 (WP-35.19) — Hammer: arm, tap one block, it is destroyed.
 *
 * The simplest of the three, and the one that proves the WP-35.18 seam: it is
 * ~15 lines of logic because the arm/target/charge flow already exists.
 *
 * **No solver re-validation, by locked decision 19.** Removing a block can never
 * make a slide-out board unsolvable — every block that could reach its gate
 * before can still reach it, since the only change is that an obstacle is gone.
 * So the caller re-checks win/stuck and nothing else; running the solver here
 * would cost up to a second per tap to confirm something already known.
 */
import { BlockJamAudioId } from '../../constants/audio-ids';
export const HAMMER_ID = 'hammer';
export const hammerEffect = {
    /** Any block on the board — the hammer has no preconditions. */
    targets(state) {
        return state.blocks.map((b) => b.id);
    },
    apply(state, targetBlockId) {
        // A target that is not on the board is not an error to throw on — the board
        // can change between arming and the tap — it is simply nothing to do, and
        // `null` is how the caller already spells "no charge was worth taking".
        if (!state.blocks.some((b) => b.id === targetBlockId))
            return null;
        return {
            blocks: state.blocks.filter((b) => b.id !== targetBlockId),
            removedIds: [targetBlockId],
        };
    },
    // Module 139 — the How to Play swing, crack and break, not the generic smash.
    fx: 'hammer',
    impactAudioId: BlockJamAudioId.POWERUP_HAMMER,
};
